import {css} from '@emotion/react'
import {useStaticQuery, graphql} from 'gatsby'

const translations = {
    en: {
        title: 'Zapping chats erases them, for good',
        description:
            'Your chats are saved only on your device. When you clear them, they’re permanently deleted, not saved in the cloud.',
        phoneAlt: 'A smartphone screen of the Vanish private AI chat app',
    },
    fr: {
        title: 'Effacer les chats les supprime définitivement',
        description:
            'Vos conversations sont enregistrées uniquement sur votre appareil. Lorsque vous les effacez, elles sont supprimées définitivement et ne sont pas stockées dans le cloud.',
        phoneAlt: "Écran de smartphone montrant l’application de chat IA privée Vanish",
    },
    de: {
        title: 'Chats zappen löscht sie endgültig',
        description:
            'Ihre Chats werden nur auf Ihrem Gerät gespeichert. Wenn Sie sie löschen, werden sie dauerhaft gelöscht, nicht in der Cloud gespeichert.',
        phoneAlt: 'Ein Smartphone-Bildschirm der Vanish Private-AI-Chat-App',
    },
    nl: {
        title: 'Chats zappen wist ze voorgoed',
        description:
            'Uw chats worden alleen op uw apparaat opgeslagen. Wanneer u ze wist, worden ze permanent verwijderd, niet opgeslagen in de cloud.',
        phoneAlt: 'Een smartphonescherm van de Vanish privé-AI-chatapp',
    },
}

// eslint-disable-next-line no-unused-vars
const Section2 = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    const images = useStaticQuery(graphql`
        query VanishSection2Images {
            modelPhone: file(relativePath: {eq: "vanish/phones/app-recent-chats.png"}) {
                publicURL
            }
            modelPhoneB: file(relativePath: {eq: "vanish/phones/app-recent-chats-b.png"}) {
                publicURL
            }
        }
    `)

    return (
        <section
            className="vanish-section2"
            css={css`
                width: 100%;
                padding: 100px 35px;
                background: linear-gradient(180deg, #1b0432 0%, #5a1871 100%);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 80px;
                box-sizing: border-box;
                z-index: 1;
                @media (max-width: 910px) {
                    gap: 40px;
                }
                @media (max-width: 765px) {
                    flex-direction: column;
                    padding: 72px 20px 0;
                    gap: 24px;
                }
            `}
        >
            <div
                className="content-wrapper"
                css={css`
                    max-width: 450px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    flex: 1;
                    justify-content: center;
                    text-align: left;
                    @media (max-width: 765px) {
                        align-items: center;
                        text-align: center;
                    }
                    @media (max-width: 480px) {
                        max-width: none;
                    }
                `}
            >
                <h2
                    css={css`
                        color: var(--text-primary, #f2f3fb);
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 60px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        letter-spacing: 0.5px;
                        margin-bottom: 48px;
                        @media (max-width: 985px) {
                            font-size: 48px;
                            line-height: 56px;
                        }
                        @media (max-width: 480px) {
                            font-size: 42px;
                            line-height: 50px; /* 119.048% */
                            margin-bottom: 32px;
                        }
                    `}
                >
                    {text.title}
                </h2>

                <p
                    css={css`
                        color: var(--text-primary, #ebecf7);
                        font-family: Inter;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px; /* 133.333% */
                    `}
                >
                    {text.description}
                </p>
            </div>

            {/* Phone Mockup - Positioned at bottom */}
            <div
                className="phone-mockup"
                css={css`
                    display: flex;
                    justify-content: center;
                    flex-shrink: 0;
                `}
            >
                <img
                    src={images.modelPhone.publicURL}
                    alt={text.phoneAlt}
                    loading="eager"
                    css={css`
                        height: 658px;
                        width: auto;
                        filter: drop-shadow(0 15px 40px rgba(0, 0, 0, 0.4));
                        display: block;
                        @media (max-width: 870px) {
                            height: 500px;
                        }
                        @media (max-width: 765px) {
                            display: none;
                        }
                    `}
                />
                <img
                    src={images.modelPhoneB.publicURL}
                    alt={text.phoneAlt}
                    loading="eager"
                    css={css`
                        height: auto;
                        width: 304px;
                        filter: drop-shadow(0 15px 40px rgba(0, 0, 0, 0.4));
                        display: none;
                        @media (max-width: 765px) {
                            display: block;
                        }
                    `}
                />
            </div>
        </section>
    )
}

export default Section2
